import { Calendar, Plus } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/hooks/useTranslation";

interface EmptyEventsStateProps {
  onCreateEvent: () => void;
  currentLocale: string;
}

export function EmptyEventsState({
  onCreateEvent,
}: EmptyEventsStateProps) {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent className="py-12 text-center">
        <Calendar className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
        <h3 className="text-lg font-semibold mb-2">
          {t('events.noEvents')}
        </h3>
        <p className="text-muted-foreground mb-4">
          {t('events.noEventsDescription')}
        </p>
        <Button onClick={onCreateEvent}>
          <Plus className="mr-2 h-4 w-4" />
          {t('events.create')}
        </Button>
      </CardContent>
    </Card>
  );
}

